import { env } from "configs/EnvironmentConfig";
import { ALL_BU } from "constants/DashboardContanst";
import fetch from "../auth/FetchInterceptor";

const formatDataService = {};

// Đăng ký sử dụng
formatDataService.listRegistryInvoices = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/registry-invoices`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
    },
  });
};
// reviewPdfRegisterInvoice
formatDataService.reviewPdfRegisterInvoice = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/registry-invoices/review-pdf/${id}`,
    method: "get",
  });
};
// Kiểm tra tờ khai hiệu lực
formatDataService.checkInvoicesCurrent = function () {
  return fetch({
    url: `${env.API_MSP}/registry-invoices/current`,
    method: "get",
    params: {
      expand: "registryInvoiceCas",
    },
  });
};
// Detail Đăng ký sử dụng
formatDataService.detailRegistryInvoices = function (id) {
  return fetch({
    url: `${env.API_MSP}/registry-invoices/${id}`,
    method: "get",
    params: {
      expand:
        "registryInvoiceCas,registryInvoiceTcgp,registryInvoiceTctn,registryInvoiceDvhtpt,registryInvoiceTnsdung,registryInvoiceDkth",
    },
  });
};

// Create Đăng ký sử dụng
formatDataService.createRegistryInvoices = function (data, bu_code) {
  return fetch({
    url: `${env.API_MSP}/registry-invoices`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// Edit Đăng ký sử dụng
formatDataService.editRegistryInvoices = function (data, id) {
  return fetch({
    url: `${env.API_MSP}/registry-invoices/${id}`,
    method: "put",
    data,
  });
};

// Ủy quyền lập hóa đơn
formatDataService.listRegistryDelegate = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort
) {
  return fetch({
    url: `${env.API_MSP}/registry-delegates`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
    },
  });
};

// Detail Ủy quyền lập hóa đơn
formatDataService.detailRegistryDelegate = function (id) {
  return fetch({
    url: `${env.API_MSP}/registry-delegates/${id}`,
    method: "get",
    params: {
      expand: "registryDelegateCas,registryDelegateInvoices",
    },
  });
};

// Create Ủy quyền lập hóa đơn
formatDataService.createRegistryDelegate = function (data) {
  return fetch({
    url: `${env.API_MSP}/registry-delegates`,
    method: "post",
    data,
  });
};

// Edit Ủy quyền lập hóa đơn
formatDataService.editRegistryDelegate = function (data, id) {
  return fetch({
    url: `${env.API_MSP}/registry-delegates/${id}`,
    method: "put",
    data,
  });
};

// Đề nghị cấp HDDT có mã
formatDataService.listRequestInvoiceCodes = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort
) {
  return fetch({
    url: `${env.API_MSP}/request-invoice-codes`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
    },
  });
};

// Detail Đề nghị cấp HDDT có mã
formatDataService.detailRequestInvoiceCode = function (id) {
  return fetch({
    url: `${env.API_MSP}/request-invoice-codes/${id}`,
    method: "get",
    params: {
      expand: "requestContent",
    },
  });
};

// Create Đề nghị cấp HDDT có mã
formatDataService.createRequestInvoiceCode = function (data) {
  return fetch({
    url: `${env.API_MSP}/request-invoice-codes`,
    method: "post",
    data,
  });
};

// Edit Đề nghị cấp HDDT có mã
formatDataService.editRequestInvoiceCode = function (data, id) {
  return fetch({
    url: `${env.API_MSP}/request-invoice-codes/${id}`,
    method: "put",
    data,
  });
};

// downloadFileXMLRegistryInvoices
formatDataService.downloadFileXMLRegistryInvoices = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/registry-invoices/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};
// downloadFilePDFRegistryInvoices approve-pdf-error
formatDataService.downloadFilePDFRegistryInvoices = ({
  resource_id,
  downloadType,
  responseType,
}) => {
  if (downloadType == "approve-pdf-error") {
    return fetch({
      url: `${env.API_MSP}/invoice-errors/approve-pdf/${resource_id}`,
      method: "get",
    });
  } else if (downloadType == "approve-pdf-tax-deduct-error") {
    return fetch({
      url: `${env.API_MSP}/tax-deduct-errors/approve-pdf/${resource_id}`,
      method: "get",
    });
  } else {
    return fetch({
      url: `${env.API_MSP}/registry-invoices/${downloadType + "/" + resource_id
        }`,
      method: "get",
    });
  }
};
// downloadFileXMLRegistryDelegates
formatDataService.downloadFileXMLRegistryDelegates = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/registry-delegates/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// downloadFileXMLRequestInvoiceCode
formatDataService.downloadFileXMLRequestInvoiceCode = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/request-invoice-codes/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// releaseRegistryInvoices
formatDataService.releaseRegistryInvoices = id => {
  return fetch({
    url: `${env.API_MSP}/registry-invoices/release/${id}`,
    method: "post",
  });
};

// releaseRegistryDelegates
formatDataService.releaseRegistryDelegates = id => {
  return fetch({
    url: `${env.API_MSP}/registry-delegates/release/${id}`,
    method: "post",
  });
};

// releaseRequestInvoiceCodes
formatDataService.releaseRequestInvoiceCodes = id => {
  return fetch({
    url: `${env.API_MSP}/request-invoice-codes/release/${id}`,
    method: "post",
  });
};

// previewPDF
formatDataService.previewPDF = function (resourceId) {
  return fetch({
    url: `${env.API_MSP}/case-docsigns/file/${resourceId}`,
    method: "get",
    responseType: "blob",
  });
};

// transfer
formatDataService.transfer = function (data) {
  return fetch({
    url: `${env.API_MSP}/hooks/transfer`,
    method: "post",
    data,
  });
};

// errorRelease
formatDataService.errorRelease = function (id, path) {
  return fetch({
    url: `${env.API_MSP}/${path}/error/${id}`,
    method: "get",
  });
};

// historyTransfer
formatDataService.historyTransfer = function (id, path) {
  let type = null;
  let typeAction = undefined;
  console.log("FormatDataService historyTransfer", { path });
  switch (path) {
    case "invoices":
    case "invoice-tickets":
      type = 1;
      break;
    case "registry-invoices":
      type = 2;
      break;
    case "invoice-errors":
      type = 3;
      break;
    case "invoices-send-mail":
      type = 1;
      typeAction = 5;
      break;
    case "invoice-phase-pos":
      type = 5;
      break;
    case "invoice-cycles":
      type = 4;
      break;
    case "tax-deduct-send-mail":
      type = 7;
      typeAction = 5;
      break;
    // CTKT
    case "tax-deduct-details":
      type = 7;
      break;
    // Tờ khai CTKT
    case "registry-tax-deducts":
      type = 5;
      break;
    default:
      break;
  }
  if (type) {
    const url = `${env.API_MSP}/histories`;
    return fetch({
      url: url,
      method: "get",
      params: {
        "filter[object_id]": id,
        "filter[type]": type,
        "filter[type_action]": typeAction,
      },
    });
  } else {
    return fetch({
      url: `${env.API_MSP}/${path}/history/${id}`,
      method: "get",
    });
  }
};

// chứng từ
formatDataService.listTaxDeducts = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort,
  bu_code,
  bu_parent
) {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-details`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code,
      bu_parent,
    },
  });
};

// Detail chứng từ
formatDataService.detailTaxDeducts = function (id) {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-details/${id}`,
    method: "get",
  });
};

// Lấy thông tin liên kết chứng từ
formatDataService.getDataLinkTaxDeduct = function ({ id, isGetChild }) {
  return fetch({
    url: `${env.API_MSP}/link-tax-deducts/${isGetChild ? "child" : "root"
      }/${id}`,
    method: "get",
  });
};

// downloadFileXMLTaxDeducts
formatDataService.downloadFileXMLTaxDeducts = (resource_id, responseType) => {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-details/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// Kiểm tra tờ khai hiệu lực
formatDataService.checkInvoicesCurrent = function () {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-details/current`,
    method: "get",
    params: {
      expand: "registryInvoiceCas",
    },
  });
};

// Create chứng từ
formatDataService.createTaxDeducts = function (data, bu_code) {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-details`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// Thay thế chứng từ
formatDataService.replaceTaxDeducts = function (data) {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-details/replace`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Điều chỉnh chứng từ
formatDataService.adjustTaxDeducts = function (data) {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-details/adjust`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Phát hành chứng từ
formatDataService.releaseTaxDeducts = function ({ data, bu_code }) {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-details`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// Edit chứng từ
formatDataService.editTaxDeducts = function (data, id) {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-details/${id}`,
    method: "put",
    data,
  });
};

// Delete chứng từ
formatDataService.deleteTaxDeducts = function (id) {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-details/${id}`,
    method: "delete",
  });
};

// Hủy chứng từ
formatDataService.cancelTaxDeducts = function (ids) {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-details/cancel`,
    method: "post",
    data: {
      ids,
    },
  });
};

// releaseTaxDeducts
formatDataService.releaseTaxDeducts = id => {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-details/release/${id}`,
    method: "post",
  });
};

// Lấy thông tin bu parent của chứng từ
formatDataService.getParentBuTaxDeduct = () => {
  return fetch({
    url: `${env.API_MSP}/business-units/parent-tax-deduct`,
    method: "get",
  });
};

// tờ khai chứng từ
formatDataService.listTaxDeductsRegistry = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort,
  bu_code,
  bu_parent
) {
  return fetch({
    url: `${env.API_MSP}/registry-tax-deducts`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code,
      bu_parent,
      expand: "resource_list",
    },
  });
};

// Detail tờ khai chứng từ
formatDataService.detailTaxDeductsRegistry = function (id) {
  return fetch({
    url: `${env.API_MSP}/registry-tax-deducts/${id}`,
    method: "get",
    params: {
      expand: "registryTaxDeductCas",
    },
  });
};

// downloadFileXMLTaxDeductsRegistry
formatDataService.downloadFileXMLTaxDeductsRegistry = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/registry-tax-deducts/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// Create tờ khai chứng từ
formatDataService.createTaxDeductsRegistry = function (data, bu_code) {
  return fetch({
    url: `${env.API_MSP}/registry-tax-deducts`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// Edit tờ khai chứng từ
formatDataService.editTaxDeductsRegistry = function (data, id) {
  return fetch({
    url: `${env.API_MSP}/registry-tax-deducts/${id}`,
    method: "put",
    data,
  });
};

// Delete tờ khai chứng từ
formatDataService.deleteTaxDeductsRegistry = function (id) {
  return fetch({
    url: `${env.API_MSP}/registry-tax-deducts/${id}`,
    method: "delete",
  });
};

// Phát hành tờ khai chứng từ
formatDataService.releaseTaxDeductsRegistry = id => {
  return fetch({
    url: `${env.API_MSP}/registry-tax-deducts/release/${id}`,
    method: "post",
  });
};

export default formatDataService;
